import React, { useContext, useEffect, useState } from 'react';
import { clearUserCredentials, getAccessToken, getUsername, setAccessToken } from '../../backend/credentials';
import MfaResult from '../../models/MfaResult';
import { SalesContext } from '../../SalesContext';
import { Button } from '../core/button';
import { LoginForm } from './login_form';
import { MfaForm } from './mfa_form';
import styles from './login.module.scss';

/**
 * View for logging in to the app.
 */
const LoginView: React.FC = () => {
  const [mfaResult, setMfaResult] = useState<MfaResult>(null);

  const { userToken, setUserToken } = useContext(SalesContext);

  useEffect(() => {
    if (userToken) {
      document.location.hash = '#creditcheck';
    }
  }, [userToken]);

  function onAuthorized() {
    setUserToken(getAccessToken());

    document.getElementById('creditcheck').scrollIntoView({ behavior: 'smooth' });
  }

  const username = getUsername();

  return (
    <div id="login" className="view">
      {
        username ? (
          <h2>Inloggad som {username}</h2>
        ) : (
            <h2>Logga in</h2>
          )
      }
      {
        userToken ? (
          <div>
            <Button onClick={() => {
              clearUserCredentials();
              setAccessToken(null);
              setUserToken(null);
            }}>
              Logga ut
            </Button>
          </div>
        ) : (
            mfaResult ? (
              <MfaForm
                metadata={mfaResult}
                onAuthorized={onAuthorized} />
            ) : (
                <LoginForm
                  onMfaRequired={setMfaResult}
                  onAuthorized={onAuthorized} />
              )
          )
      }
    </div>
  )
}

export default LoginView;